import z from "zod";

export const sailingScheduleSchema = z.object({
	schedule: z.string().min(1).max(255),
});

export type SailingScheduleSchemaInput = z.input<typeof sailingScheduleSchema>;
export type SailingScheduleSchemaOutput = z.output<typeof sailingScheduleSchema>;
